import { render, staticRenderFns } from "./ViewLoans.vue?vue&type=template&id=75bd7d77"
import script from "./ViewLoans.vue?vue&type=script&lang=js"
export * from "./ViewLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports